module.exports = __webpack_public_path__ + "static/media/digicon_lite_demo.677b143.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/digicon_lite_demo.mp4
// module id = 4rDe
// module chunks = 0